import type { SVGProps } from 'react';

type Props = { tagline: string } & SVGProps<SVGSVGElement>;

export const MainIllustration = ({ tagline, ...props }: Props): JSX.Element => (
  <svg
    width="350"
    height="122"
    viewBox="0 0 350 122"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
    {...props}
  >
    <text
      fill="var(--xdlColorText)"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="XING Sans"
      fontSize="16"
      fontWeight="bold"
      letterSpacing="0px"
    >
      <tspan x="123.328" y="17.36">
        {tagline}
      </tspan>
    </text>
    <path
      d="M120.704 30.9201L223.434 23.4659C245.743 21.8471 265.14 38.6197 266.759 60.9286C268.378 83.2375 251.605 102.635 229.296 104.253L126.566 111.708C104.257 113.326 84.8601 96.5538 83.2413 74.245C81.6225 51.9361 98.3952 32.5389 120.704 30.9201Z"
      fill="var(--xdlColorBackground)"
    />
    <path
      d="M120.704 30.9201L223.434 23.4659C245.743 21.8471 265.14 38.6197 266.759 60.9286C268.378 83.2375 251.605 102.635 229.296 104.253L126.566 111.708C104.257 113.326 84.8601 96.5538 83.2413 74.245C81.6225 51.9361 98.3952 32.5389 120.704 30.9201Z"
      stroke="#1D2124"
    />
    <path
      d="M224.5 68.7076L221.402 42.5833L231.455 41.8538L232.16 68.1517L224.5 68.7076ZM228.725 73.8753C231.777 73.6539 234.349 75.9337 234.562 78.866C234.779 81.8582 232.563 84.4854 229.511 84.7069C226.519 84.924 223.947 82.6441 223.73 79.652C223.518 76.7197 225.733 74.0925 228.725 73.8753Z"
      fill="var(--xdlColorText)"
    />
    <path
      d="M208.795 86.2102C205.264 86.4664 202.279 85.1189 200.182 82.7445L199.924 85.8312L191.546 86.4391L188.324 42.0359L197.706 40.3325L198.93 57.2081C200.654 54.4361 203.649 52.5945 207.179 52.3383C214.779 51.7869 219.424 57.7664 220.197 68.4184C220.909 78.2326 216.694 85.637 208.795 86.2102ZM205.543 79.5281C208.834 79.2892 210.921 76.551 210.383 69.1305C209.797 61.0517 207.504 59.2931 204.511 59.5102C202.357 59.6665 200.602 61.1775 199.395 63.6113L200.354 76.8365C201.69 78.6646 203.508 79.6757 205.543 79.5281Z"
      fill="var(--xdlColorText)"
    />
    <path
      d="M171.753 88.8979C162.119 89.597 155.743 83.8033 154.965 73.0915C154.227 62.9182 159.605 55.7903 169.3 55.0868C178.994 54.3834 185.311 60.1815 186.088 70.8933C186.826 81.0666 181.448 88.1945 171.753 88.8979ZM171.25 81.9562C175.079 81.6783 176.773 78.4873 176.274 71.6054C175.761 64.544 173.633 61.7507 169.804 62.0286C165.974 62.3065 164.28 65.4974 164.779 72.3793C165.292 79.4408 167.42 82.2341 171.25 81.9562Z"
      fill="var(--xdlColorText)"
    />
    <path
      d="M136.779 93.6016C142.013 91.1163 142.587 88.2473 142.231 83.3402L139.703 48.5117L149.518 47.7996L152.071 82.9871C152.831 93.4595 146.752 97.5702 139.916 100.352L136.779 93.6016Z"
      fill="var(--xdlColorText)"
    />
    <path
      d="M244.036 68.4808C243.798 68.1118 244.117 67.6369 244.549 67.7182L288.675 76.0311C289.098 76.1108 289.23 76.653 288.89 76.9176L279.657 84.112C278.844 84.7452 278.897 85.9912 279.76 86.5531L296.675 97.5596C296.906 97.7095 296.971 98.0177 296.823 98.2491L291.658 106.307C291.507 106.543 291.191 106.608 290.959 106.453L273.34 94.6453C272.495 94.0794 271.344 94.5 271.063 95.477L268.415 104.693C268.296 105.105 267.746 105.187 267.513 104.827L244.036 68.4808Z"
      fill="#1D2124"
      stroke="#1D2124"
    />
    <path
      d="M245.034 64.4808C244.796 64.1118 245.115 63.6369 245.547 63.7182L289.673 72.0311C290.096 72.1108 290.228 72.653 289.888 72.9176L280.655 80.112C279.842 80.7452 279.895 81.9912 280.758 82.5531L297.673 93.5596C297.904 93.7095 297.969 94.0177 297.821 94.2491L292.656 102.307C292.505 102.543 292.189 102.608 291.957 102.453L274.338 90.6453C273.493 90.0794 272.342 90.5 272.061 91.477L269.413 100.693C269.294 101.105 268.744 101.187 268.511 100.827L245.034 64.4808Z"
      fill="white"
      stroke="#1D2124"
    />
    <path
      d="M70 107.704L71.0309 110.988C71.3491 112.311 72.38 113.368 73.7291 113.686L77 114.704L73.7164 115.735C72.3927 116.053 71.3364 117.084 71.0182 118.433L70 121.704L68.9691 118.42C68.6509 117.097 67.62 116.04 66.2709 115.722L63 114.704L66.2836 113.673C67.6073 113.355 68.6636 112.324 68.9818 110.975L70 107.704Z"
      fill="var(--xdlColorText)"
    />
    <path
      d="M287 45.7041L288.031 48.9877C288.349 50.3114 289.38 51.3677 290.729 51.6859L294 52.7041L290.716 53.735C289.393 54.0532 288.336 55.0841 288.018 56.4332L287 59.7041L285.969 56.4205C285.651 55.0968 284.62 54.0405 283.271 53.7223L280 52.7041L283.284 51.6732C284.607 51.355 285.664 50.3241 285.982 48.975L287 45.7041Z"
      fill="var(--xdlColorText)"
    />
    <path
      d="M253.375 17.2646C263.638 21.2548 272.463 29.5089 275.111 40.4285"
      stroke="var(--xdlColorText)"
      strokeMiterlimit="10"
    />
    <path
      d="M266.994 11.3062C273.139 14.7735 278.001 19.7819 281.173 25.5882"
      stroke="var(--xdlColorText)"
      strokeMiterlimit="10"
    />
    <g clipPath="url(#clip0_1091_57415)">
      <path
        d="M106.811 33.9849C88.6402 26.4581 67.8082 35.0869 60.2814 53.2578C52.7545 71.4287 61.3832 92.2607 79.5542 99.7875C97.7251 107.314 118.557 98.6856 126.084 80.5147C133.611 62.3438 124.982 41.5118 106.811 33.9849Z"
        fill="#1D2124"
        stroke="#1D2124"
      />
      <path
        d="M58.2427 98.3506L50.105 106.099C48.9524 107.26 48.9555 109.143 50.1138 110.302C51.2748 111.463 53.1636 111.463 54.3247 110.302H54.3257L61.7583 102.499L84.9663 78.1416L82.2788 75.4541L58.2427 98.3506Z"
        fill="#1D2124"
        stroke="#1D2124"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.2935 74.4926L60.7546 99.2032L53.3129 107.014C51.9565 108.371 49.7504 108.371 48.394 107.014C47.0376 105.658 47.0376 103.452 48.394 102.095L56.5323 94.3476L80.921 71.1201"
        fill="#A456F6"
      />
      <path
        d="M84.2935 74.4926L60.7546 99.2032L53.3129 107.014C51.9565 108.371 49.7504 108.371 48.394 107.014C47.0376 105.658 47.0376 103.452 48.394 102.095L56.5323 94.3476L80.921 71.1201"
        stroke="#1D2124"
        strokeMiterlimit="10"
      />
      <path
        d="M92.305 99.5727C72.3617 99.5727 56.1944 83.4054 56.1944 63.4621C56.1944 43.5188 72.3617 27.3516 92.305 27.3516C112.248 27.3516 128.416 43.5188 128.416 63.4621C128.416 83.4054 112.248 99.5727 92.305 99.5727Z"
        fill="#A456F6"
        stroke="#1D2124"
        strokeMiterlimit="10"
      />
      <path
        d="M92.3051 95.0764C74.8452 95.0764 60.6912 80.9224 60.6912 63.4625C60.6912 46.0027 74.8452 31.8486 92.3051 31.8486C109.765 31.8486 123.919 46.0027 123.919 63.4625C123.919 80.9224 109.765 95.0764 92.3051 95.0764Z"
        fill="white"
        stroke="#1D2124"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.3758 51.9307C82.5299 51.9307 72.8135 56.7334 66.2163 64.3229C72.8135 71.9071 82.5299 76.7151 93.3758 76.7151C104.222 76.7151 113.938 71.9123 120.535 64.3229C113.933 56.7334 104.216 51.9307 93.3758 51.9307Z"
        fill="white"
        stroke="#1D2124"
        strokeMiterlimit="10"
      />
      <path
        d="M93.3755 56.1621C97.8796 56.1621 101.532 59.8133 101.532 64.3174C101.532 68.8216 97.8797 72.4736 93.3755 72.4736C88.8714 72.4735 85.2202 68.8215 85.2202 64.3174C85.2204 59.8134 88.8715 56.1623 93.3755 56.1621Z"
        fill="#1D2124"
        stroke="#1D2124"
      />
      <path
        d="M93.376 51.9301V42.6201"
        stroke="#1D2124"
        strokeMiterlimit="10"
      />
      <path
        d="M81.1472 53.8985L77.5425 45.3115"
        stroke="#1D2124"
        strokeMiterlimit="10"
      />
      <path
        d="M105.151 53.8985L108.75 45.3115"
        stroke="#1D2124"
        strokeMiterlimit="10"
      />
    </g>
    <path
      d="M109 12.8516L109.589 14.7279C109.771 15.4843 110.36 16.0879 111.131 16.2697L113 16.8516L111.124 17.4407C110.367 17.6225 109.764 18.2116 109.582 18.9825L109 20.8516L108.411 18.9752C108.229 18.2188 107.64 17.6152 106.869 17.4334L105 16.8516L106.876 16.2625C107.633 16.0807 108.236 15.4916 108.418 14.7207L109 12.8516Z"
      fill="var(--xdlColorText)"
    />
    <defs>
      <clipPath id="clip0_1091_57415">
        <rect
          width="95"
          height="95"
          fill="white"
          transform="translate(45 19.7041)"
        />
      </clipPath>
    </defs>
  </svg>
);
